export function SafeAreaSpacerTop() {
    return <div className='safeAreaWrapperTop'></div>;
}

export function SafeAreaSpacerBottom() {
    return <div className='safeAreaWrapperBottom'></div>;
}
